"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _settings = require("./settings");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base notification structure and styles
 */
var BaseNotification = function BaseNotification(_ref) {
  var className = _ref.className,
      visible = _ref.visible,
      type = _ref.type,
      children = _ref.children;
  var styles = (0, _classnames.default)('notification', className, "-".concat(type), {
    'is-visible': visible
  });
  return _react.default.createElement("div", {
    className: styles,
    style: {
      position: 'relative'
    }
  }, children);
};

BaseNotification.defaultProps = {
  visible: false
};
BaseNotification.propTypes = {
  /**
   * The type of notification component (Warning, Information, Error, Success)
   */
  type: _propTypes.default.oneOf(_settings.notificationTypeList).isRequired,

  /**
   * Determines whether the notification is visible or not
   */
  visible: _propTypes.default.bool,

  /**
   * Css classes that can get applied to the component
   */
  className: _propTypes.default.string,

  /**
   * Child components that will get render  in the notification
   */
  children: _propTypes.default.node
};
var _default = BaseNotification;
exports.default = _default;